import { useState } from "react";
import reload from "../../assets/icons/reload.svg";
import CustomTabsV2 from "../universal/CustomTabsV2";
import CollapsibleRightPanel from "../universal/CollapsibleRightPanel";
import { AddVideosHooks } from "../../screens/Videos/hooks/VideosHooks";
import DropdownWithTags from "../universal/DropdownWithTags";
import LayoutDropdown from "../universal/LayoutDropdown";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import edit from "../../assets/icons/edit.svg";
import close from "../../assets/icons/close.svg";
import ReactModal from "react-modal";
import { ImCross } from "react-icons/im";
import LanguageDrawer from "../universal/LanguageDrawer";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { FaInfoCircle, FaChevronDown, FaChevronUp } from "react-icons/fa";
import UploadControlsV2 from "../TWG/UploadControlsV2";
import RelatedVideoInput from "../categories/RelatedVideoInput";
import VideoLibraryModal from "../TWG/VideoLibraryModal";

// Custom TimePicker Component to match the provided image
const TimePicker = ({ value, onChange, label, name }) => {
  const [isOpen, setIsOpen] = useState(false);
  const hours = Array.from({ length: 13 }, (_, i) => i + 9); // 9 AM to 9 PM
  const formatTime = (hour) => {
    const period = hour >= 12 ? 'p.m.' : 'a.m.';
    const formattedHour = hour > 12 ? hour - 12 : hour;
    return `${formattedHour}:00 ${period}`;
  };

  const times = hours.map(formatTime);

  const handleTimeSelect = (time) => {
    onChange({ target: { name, value: time } });
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <label className="text-[12px] text-greyish font-medium flex items-center gap-2">
        {label} *
      </label>
      <div
        className="flex items-center justify-between bg-blackish p-2 w-full text-white text-[14px] mt-2 rounded-md h-10 cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{value || "Select Time"}</span>
        {isOpen ? <FaChevronUp className="text-greyish" /> : <FaChevronDown className="text-greyish" />}
      </div>
      {isOpen && (
        <ul className="absolute z-10 w-full bg-[#202020] border border-greyish border-opacity-30 rounded-md mt-1 max-h-48 overflow-y-auto">
          {times.map((time) => (
            <li
              key={time}
              className={`p-2 cursor-pointer hover:bg-blackish text-white ${value === time ? 'font-bold' : ''}`}
              onClick={() => handleTimeSelect(time)}
            >
              {time}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const AddEventsFields = ({ setLoading, data }) => {
  const {
    activeTab,
    activeLanguageDetails,
    setActiveLanguageDetails,
    setActiveTab,
    handleInputChange,
    handleFileInputChange,
    handleSave,
    readLanguageData,
    videoInputs,
    videoErrors,
    videoUrlsInputs,
    showVideoLibraryModal,
    setShowVideoLibraryModal,
    setVideoUrlsInputs,
    setDownloadUrlsInputs,
    setTumbNailUrlsInputs,
    tumbNailUrlsInputs,
    UdownloadrlsInputs,
    handleChange,
    selectedOptions,
    setSelectedOptions,
    deleteRelatedVideo,
    setSelectedRelatedVideoIndex,
    handleDropdownChange,
    setLayoutValues,
    handleVideoLayoutChange,
    layoutValues,
    initialLayoutValues,
    setLayoutInfo,
    layoutInfo,
    handleDateChange,
    handleAddLayoutToArray,
    layoutArray,
    setAddedLayout,
    addedLayout,
    handleVideoDateChange,
    options,
    handleDeleteLayoutFromArray,
    setIsLayoutEdit,
    isLayoutEdit,
    setEditLayoutIndex,
    setEditTargetLayout,
    editTargetLayout,
    handleLayoutUpdate,
    updateStateWithTranslation,
    handleCommonTumbNailInputChange,
    setCommonUrlsInputs,
    commonVideoUrlsInputs,
    previewUrlsInputs,
    setPreviewUrlsInputs,
    languagemeta,
    setIsLanguageSave,
    handleSaveLanguage,
    handleLibraryVideoSelection,
    handleSendNotification
  } = AddVideosHooks(setLoading, data);

  const [showModal, setShowModal] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");


  return (
    <div className="flex flex-col md:flex-row h-full w-full flex-1 rounded-2xl overflow-hidden">
      <div className="flex h-full flex-1">
        <LanguageDrawer
          languageData={readLanguageData}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setActiveLanguageDetails={setActiveLanguageDetails}
          languagemeta={languagemeta}
          setIsLanguageSave={setIsLanguageSave}
        />
        <div className="flex h-full flex-1">
          <div className="flex flex-col h-full w-full bg-greyishV2 bg-opacity-50 md:border-l md:border-r border-greyish border-opacity-30 overflow-auto">
            <div className="flex gap-4 items-center justify-between h-[64px] px-4 border-b border-[#28292a]">
              <p className="text-white font-semibold text-lg">
                {activeTab === "en"
                  ? "Add Event"
                  : `Translate Event to ${activeLanguageDetails?.language_name}`}
              </p>
              <div className="flex items-center gap-5">
                {activeTab !== "en" && data?._id && (
                  <p
                    className="flex items-center gap-1 text-greyish text-[11px] font-medium cursor-pointer whitespace-nowrap"
                    onClick={updateStateWithTranslation}
                  >
                    <img src={reload} alt="" /> Auto fill data with google translation
                  </p>
                )}
                {data?._id && (
                  <button
                    className="text-yellowish bg-blackish font-medium text-[12px] whitespace-nowrap border border-yellowish rounded-xl py-2 px-6"
                    onClick={handleSendNotification}
                  >
                    Send Notification
                  </button>
                )}
                {activeTab === "en" ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSave}
                    >
                      {videoInputs?._id ? "Update Event" : "Save Event"}
                    </button>
                  </div>
                ) : data?._id ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSaveLanguage}
                    >
                      Save Language
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
            {/* TAB CONTENT  */}
            {activeTab !== "en" && !data?._id ? (
              <div className="flex items-center justify-center text-white gap-1 py-28">
                Event translation in{" "}
                <span className="italic">{activeLanguageDetails?.language_name}</span> is available
                for saved Events
              </div>
            ) : (
              <div className="px-4 my-4 h-full">
                <div className=" overflow-y-auto overflow-x-hidden">
                  <div className="grid md:grid-cols-2 grid-cols-1 grid-rows-1 gap-x-4 gap-y-4 mx-1 w-full">
                    {/* Event Title */}
                    <div className="md:col-span-2 col-span-1">
                      <label
                        htmlFor="event_title"
                        className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
                      >
                        Event Title *
                      </label>
                      <input
                        name="event_title"
                        placeholder="Enter Event Title"
                        type="text"
                        className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10`}
                        value={videoInputs?.event_title}
                        onChange={handleChange}
                      />
                      {videoErrors?.event_title && (
                        <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
                          Event Title Is Required Field
                        </p>
                      )}
                    </div>
                    {/* Event Description */}
                    <div className="md:col-span-2 col-span-1">
                      <label
                        htmlFor="event_description"
                        className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
                      >
                        Event Description *
                      </label>
                      <textarea
                        rows={6}
                        className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md`}
                        name="event_description"
                        placeholder="Enter Event Description"
                        value={videoInputs?.event_description}
                        onChange={handleChange}
                      />
                      {videoErrors?.event_description && (
                        <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
                          Event Description Is Required Field
                        </p>
                      )}
                    </div>
                    {/* Date */}
                    <div className="md:col-span-2 col-span-1">
                      <label htmlFor="event_date" className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2">
                        Date
                      </label>
                      <input
                        name="event_date"
                        type="date"
                        className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10`}
                        value={videoInputs?.event_date}
                        onChange={handleChange}
                      />
                    </div>
                    {/* Time */}
                    <div className="md:col-span-2 col-span-1">
                      <TimePicker
                        label="Time"
                        name="event_time"
                        value={videoInputs?.event_time || ""}
                        onChange={handleChange}
                      />
                    </div>
                    {/* Event Thumbnail URL */}
                    {activeTab === "en" && (
                      <UploadControlsV2
                        tooltipTitle="Upload Event Thumbnail"
                        className="my-2 col-span-2 mr-1"
                        title="Event Thumbnail *"
                        subtitle="Upload Image"
                        handleChangeUrl={(event) =>
                          handleInputChange(event, setTumbNailUrlsInputs)
                        }
                        mobileUploadProgressId="mobileUploadUrlEventThumbnail"
                        handleMobileFileUpload={(e) =>
                          handleFileInputChange(
                            setTumbNailUrlsInputs,
                            "mobileUploadUrl",
                            e.target.files[0],
                            null,
                            "mobileUploadUrlEventThumbnail",
                            false,
                            "video_thumbnails_urls"
                          )
                        }
                        mobileUploadUrl={tumbNailUrlsInputs?.mobileUploadUrl}
                        handleMobilePreview={() => {
                          setIsImage(true);
                          setShowModal(true);
                          setCurrentUrl(tumbNailUrlsInputs?.mobileUploadUrl);
                        }}
                        tabletUploadProgressId="tabletUploadUrlEventThumbnail"
                        handleTabletFileUpload={(e) =>
                          handleFileInputChange(
                            setTumbNailUrlsInputs,
                            "tabletUploadUrl",
                            e.target.files[0],
                            null,
                            "tabletUploadUrlEventThumbnail",
                            false,
                            "video_thumbnails_urls"
                          )
                        }
                        tabletUploadUrl={tumbNailUrlsInputs?.tabletUploadUrl}
                        handleTabletPreview={() => {
                          setIsImage(true);
                          setShowModal(true);
                          setCurrentUrl(tumbNailUrlsInputs?.tabletUploadUrl);
                        }}
                        webUploadProgressId="webUploadUrlEventThumbnail"
                        handleWebFileUpload={(e) =>
                          handleFileInputChange(
                            setTumbNailUrlsInputs,
                            "webUploadUrl",
                            e.target.files[0],
                            null,
                            "webUploadUrlEventThumbnail",
                            false,
                            "video_thumbnails_urls"
                          )
                        }
                        webUploadUrl={tumbNailUrlsInputs?.webUploadUrl}
                        handleWebPreview={() => {
                          setIsImage(true);
                          setShowModal(true);
                          setCurrentUrl(tumbNailUrlsInputs?.webUploadUrl);
                        }}
                        isFieldRequired={videoErrors?.video_thumbnails_urls}
                        requiredMessage="Event Thumbnail Is Required Field"
                      />
                    )}
                    {/* Live Video URL */}
                    <div className="md:col-span-2 col-span-1">
                      <label htmlFor="live_video_url" className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2">
                        Live Video URL
                      </label>
                      <input
                        name="live_video_url"
                        placeholder="Enter Live Video URL"
                        type="url"
                        className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10`}
                        value={videoInputs?.live_video_url}
                        onChange={handleChange}
                      />
                    </div>
                    {/* Place (Location) */}
                    <div className="md:col-span-2 col-span-1">
                      <label htmlFor="place" className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2">
                        Place (Location)
                      </label>
                      <input
                        name="place"
                        placeholder="Enter Place"
                        type="text"
                        className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10`}
                        value={videoInputs?.place}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            <Tooltip id="add_ministry" className="border border-greyish border-opacity-20" />
          </div>
        </div>
      </div>
      <CollapsibleRightPanel title="Stats / Layouts">
        <CustomTabsV2
          tabHeight={"h-[64px]"}
          tabsTitleArray={["Stats", "Layouts"]}
          tabsContentObject={{
            Stats: (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                {data?._id ? (
                  <div className="w-full px-8">
                    <p>
                      Views : <strong>{videoInputs?.totalViews}</strong>
                    </p>
                    <p>
                      Likes: <strong>{videoInputs?.totalLikes}</strong>
                    </p>
                  </div>
                ) : (
                  <>No stats available for video</>
                )}
              </div>
            ),
            Layouts: !data?._id ? (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                Save this video to assign the layout
              </div>
            ) : (
              <>
                <div className="mt-4 p-1">
                  <label htmlFor="relatedVideos" className="text-[12px] text-greyish font-medium">
                    Layouts
                  </label>
                  <div className="bg-blackish py-4 px-3 mt-3 rounded-lg">
                    <LayoutDropdown
                      setMyState={setLayoutValues}
                      setLayoutInfo={setLayoutInfo}
                      setAddedLayout={setAddedLayout}
                      addedLayout={addedLayout}
                      newTarget={editTargetLayout}
                      isLayoutEdit={isLayoutEdit}
                      outerTargetLayout={layoutValues?.layout_name}
                    />
                    {layoutInfo && (
                      <>
                        <div className="flex gap-3">
                          <div className="w-full">
                            <label
                              htmlFor="order"
                              className="text-[12px] text-greyish font-medium leading-4 "
                            >
                              Display Order
                            </label>
                            <input
                              type="text"
                              className={`bg-greyishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10`}
                              name="order"
                              placeholder="Enter order"
                              value={layoutValues?.order}
                              onChange={handleVideoLayoutChange}
                            />
                          </div>
                        </div>
                        <div className="flex justify-end mt-4">
                          <div className="flex gap-3">
                            {!isLayoutEdit && (
                              <button
                                className="text-greyish bg-blackishV2 font-medium text-[12px] rounded-xl py-2 px-6"
                                onClick={() => {
                                  setLayoutValues(initialLayoutValues);
                                  setLayoutInfo(false);
                                }}
                              >
                                Cancel
                              </button>
                            )}
                            {isLayoutEdit ? (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleLayoutUpdate}
                              >
                                Confirm
                              </button>
                            ) : (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleAddLayoutToArray}
                              >
                                Add
                              </button>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {layoutArray?.length > 0 &&
                  activeTab === "en" &&
                  layoutArray?.map((item, index) => (
                    <div className="w-full px-4 mt-4">
                      <div className="w-full p-2 px-4 bg-black bg-opacity-10 rounded-lg border border-opacity-25 border-white">
                        <div className="flex flex-col items-center justify-center w-full text-white">
                          <div className="flex justify-between w-full">
                            <p className="text-sm font-white font-medium text-white">
                              {item?.layout_name}
                            </p>
                            <div className="flex gap-2 justify-end items-center cursor-pointer">
                              <img
                                className="h-4"
                                src={edit}
                                alt=""
                                onClick={() => {
                                  setIsLayoutEdit(true);
                                  setEditLayoutIndex(index);
                                  setLayoutValues(item);
                                  setEditTargetLayout(item?.layout_name);
                                }}
                              />
                              <img
                                className="h-4"
                                src={close}
                                alt=""
                                onClick={() => {
                                  handleDeleteLayoutFromArray(item?._id);
                                }}
                              />
                            </div>
                          </div>
                          <div className="flex justify-between w-full mt-5 bg-blackishV2 p-1 px-2">
                            <p className="text-[10px] font-white text-white">Order</p>
                          </div>
                          <div className="flex w-full mt-2 p-1 px-2">
                            <p className="flex w-full text-xs font-white font-bold text-white">
                              {item?.order}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            ),
          }}
        />
      </CollapsibleRightPanel>
      <ReactModal isOpen={showModal} onRequestClose={() => setShowModal(false)}>
        <div className="flex justify-center h-full w-full relative">
          <div
            className="absolute top-0 right-0 cursor-pointer"
            onClick={() => setShowModal(false)}
          >
            <ImCross />
          </div>
          {isImage ? (
            <img className="h-full" src={currentUrl} />
          ) : (
            <video className="h-full" controls autoPlay>
              <source src={currentUrl} />
            </video>
          )}
        </div>
      </ReactModal>
    </div>
  );
};

export default AddEventsFields;
